// extracted by mini-css-extract-plugin
export default {"list":"feed-orders_list__E3QnJ"};